<div class="main-container">
  <app-page-header pageTitle="Support" [backLabel]="isForm ? 'Back' : ''" (back)="onBackClick()"></app-page-header>

  <div class="details-container" *ngIf="!isForm" style="height:65vh">
    <mat-card class="half-width-card" style="margin-left: 0vw !important;" aria-labelledby="short-card-title"
      appearance="outlined">
      <mat-card-title>
        <span class="sub-title">General Support</span>
      </mat-card-title>

      <mat-card-content>
        <div class="support-email">
          <span>
            <fa-icon style="margin-right:5px;color:#666666" [icon]="icons.faEnvelope"></fa-icon>
            <a href="mailto:mctpvsupport@pearson.com">mctpvsupport&#64;pearson.com</a></span>
        </div>
      </mat-card-content>
    </mat-card>
  </div>

  <div *ngIf="isForm">
    <div class="details-container">
      <mat-card class="half-width-card" aria-labelledby="short-card-title" appearance="outlined">
        <mat-card-title>
          <h2 class="help-title">Help request</h2>
        </mat-card-title>

        <span class="helpReq-details-text">Please provide detailed description of the problem and avoid including any
          passwords or other sensitive
          information.</span>

        <mat-card-content>
          <div class="formContainer">
            <form [formGroup]="supportForm">
              <mat-form-field>
                <input type="text" matInput formControlName="email" placeholder="Email" />
                <mat-error *ngIf="supportForm.get('email')?.hasError('required') && supportForm.get('email')?.touched">
                  Email id is required
                </mat-error>
                <mat-error
                  *ngIf="supportForm.get('email')?.hasError('invalidEmail') && supportForm.get('email')?.touched">
                  Please enter a valid email address (e.g., user&#64;example.com)
                </mat-error>
              </mat-form-field>

              <mat-form-field>
                <input type="text" matInput formControlName="subject" placeholder="Subject" />
                <mat-error>Subject is required</mat-error>
              </mat-form-field>

              <mat-form-field>
                <textarea matInput formControlName="description" rows="4" placeholder="Description"></textarea>
                <mat-error>Description is required</mat-error>
              </mat-form-field>

              <div align="start">
                <button mat-flat-button class="btn-clr" (click)="submit()">
                  Submit
                </button>
              </div>
            </form>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</div>